module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main